import React, { Component } from 'react'
import { connect } from 'react-redux'
import { req_single_rns_registerSpace, req_add_rns_footprintLog } from '../../api'
import queryString from 'query-string'

import { Divider, message } from 'antd'
import { addspace } from '../../utils/dataUtil'

import './register-footprint.css'


class RegisterFootprint extends Component {
    // 基礎通用參數 //////////////////////////////////////////////    
    state = {
        loading: false,
        space: '',
        item: {},
        registered: false,
        reply: {
            SpaceNid: 0,
            ContactName: '',
            ContactPhone: '',
            TagStatus: 'REGISTER'
        }
    }

    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const parsed = queryString.parse(window.location.search);
        const { space } = parsed
        this.init_data(space)
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_single_item = async () => {
        const { token } = this.props.user
        const { space } = this.state
        this.setState({ loading: true })
        const result = await req_single_rns_registerSpace(space, token)
        this.setState({ loading: false })
        const item = result
        this.setState({ item })
    }

    api_add_item = async (item) => {
        const { token } = this.props.user
        const result = await req_add_rns_footprintLog(item, token)
        if (result.status === "success") {
            // console.log(result)
            message.success(result.message)
            this.setState({ registered: true })
        } else {
            message.error(result.message)
        }
    }


    // 數據配置設定 ////////////////////////////////////////////// 
    init_data = (space) => {
        this.setState({
            space
        }, () => {
            this.api_single_item()
        })
    }


    // 操作互動處理 //////////////////////////////////////////////

    handleChange(event) {
        //console.log(event)
        const { reply } = this.state
        Object.keys(reply).forEach(propertyName => {
            if (event.target.id === propertyName && event.target.value !== null) {
                reply[propertyName] = event.target.value.trim()
            }

        });
        this.setState({ reply })
    }

    handleSubmit(event) {
        event.preventDefault()
        const { item } = this.state
        const row = this.state.reply
        const errors = []

        if (!row.ContactPhone.trim()) {
            errors.push('手機未填')
        }
        if (!row.ContactPhone.length === 10) {
            errors.push('手機號碼有誤')
        }
        if (!row.ContactName.trim()) {
            errors.push('姓名未填')
        }

        if (errors.length === 0) {
            row.SpaceNid = item.SpaceNid
            this.api_add_item(row)
        } else {
            let info = errors.join(',')
            message.error(info);
        }
    }


    render() {
        const { item, registered } = this.state
        return (
            <div id="cover" className="min-vh-100">
                <div id="cover-caption">
                    <div className="container">
                        <div className="row text-white">
                            <div className="col-xl-5 col-lg-6 col-md-8 col-sm-10 mx-auto text-center form p-4">
                                <h1 className="display-5 py-2 text-truncate">台南應用科技大學</h1>
                                <h1 className="display-4 py-2 text-truncate">實聯登記</h1>
                                <div className="px-2">

                                    <form onSubmit={this.handleSubmit}>
                                        <div className="form-row">
                                            <div className="col-lg">
                                                <div className="form-group">
                                                    <input type="text" className="form-control text-primary" name="SpaceName" id="SpaceName" defaultValue={item.SpaceName} disabled />
                                                    {addspace(item.SpaceNumber + '', 4)}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            (registered) ?
                                                (<>
                                                    <div className="form-row">
                                                        <div className="col-lg">
                                                            <div className="form-group">
                                                                <input type="button" value="成功" className="btn btn-success btn-block" disabled />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>) :
                                                (<>
                                                    <div className="form-row">
                                                        <div className="col-lg">
                                                            <div className="form-group">
                                                                <input type="number" className="form-control text-primary" name="ContactPhone" id="ContactPhone" placeholder="請輸入您行動電話" onChange={this.handleChange} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        <div className="col-lg">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control text-primary" name="ContactName" id="ContactName" placeholder="請輸入您姓名" onChange={this.handleChange} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        <input type="submit" value="確認" className="btn btn-warning btn-sm btn-block" />
                                                    </div>

                                                </>)
                                        }
                                        <div className="form-row">
                                            <Divider plain>網路與資訊中心(雲端應用組) 設計</Divider>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(RegisterFootprint)